import { render, staticRenderFns } from "./formas-de-pagamento.vue?vue&type=template&id=5db301e5"
import script from "./formas-de-pagamento.vue?vue&type=script&lang=ts"
export * from "./formas-de-pagamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports